import React from "react";
import DimensionInfo from "../models/DimensionInfo"
import MarkerInfo, { AnchorState } from "../models/MarkerInfo"
import MapWrapper from "./map/MapWrapper"

const DimensionsMap: React.FC<{data: DimensionInfo[]}> = (props) => {
    const [markers, setMarkers] = React.useState<MarkerInfo[]>([]);

    React.useEffect(() => {
        let marks = [];
        for (const dim of props.data) {
            if (dim.locations) {
                for (const loc of dim.locations) {
                    if (loc.gps_coords && (loc.gps_coords.lat != 0 || loc.gps_coords.lng != 0)) {
                        marks.push({
                            id: '',
                            pos: loc.gps_coords,
                            //icon: '', //'img/marker-blue.png',
                            icon: '',//'img/cloud_anchor_pin.png',
                            title: loc.name,
                            popupInfo: "Popup info",
                            state: AnchorState.None
                        });
                    }
                }
            }
        }
        setMarkers(marks);
    }, []);

    {/*<div className="map-wrap"></div>*/}
    return (
        <>
            {/*<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d325516.3770455823!2d30.532690549999998!3d50.402035500000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4cf4ee15a4505%3A0x764931d2170146fe!2z0JrQuNGX0LIsIDAyMDAw!5e0!3m2!1suk!2sua!4v1663766894188!5m2!1suk!2sua"></iframe>*/}
            <MapWrapper markers = {{list: markers}}/>
        </>
    );
};

export default DimensionsMap;
